import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f393d41"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://vk.com/newcyberrussia" }, "«русский киберслон»")
], -1))

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const footerClassName = "footer";

const year = computed(() => new Date().getFullYear());

const classes = computed(() => [footerClassName]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", null, "© " + _toDisplayString(_unref(year)) + " г.", 1),
    _hoisted_1
  ], 2))
}
}

})